// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_ncx-admin_ncx-admin_module_ts":"bbbecbc9e2d30c6c","src_app_ncx-dev_ncx-dev_module_ts":"805b9a27f1feb023"}[chunkId] + ".js";
};